<template>
  <div class="p-3">

    <div v-if="$loading.is" class="fixed left-0 top-0 w-full h-full z-50 flex justify-center items-center bg-gray-100/50">
      <div class="border shadow flex justify-center items-center px-3 py-2 bg-gray-100">
        <div class="w-5 h-5 border-4 mr-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        <p class="italic">Loading</p>
      </div>
    </div>

    <Login ref="modalLogin" />

    <!-- <MobileNavbar ref="mobileNavbar" /> -->
    <nav class="fixed left-0 top-0 z-40 w-full h-10 py-6 px-4 bg-white border-b flex justify-between items-center">
      <div class="flex justify-start items-center">
        <p class="text-sm font-semibold italic ml-2">{{ email ? email : '-' }}</p>
      </div>
      <div>
        <button @click="buttonLoginHandle" class="bg-gray-100 border w-8 h-8 rounded mr-1">
          <i :class="$auth.is ? 'text-red-500' : 'text-green-500'" class="fa-solid fa-right-to-bracket"></i>
        </button>
        <!-- <button @click="$refs.mobileNavbar.is_show = true" class="bg-gray-100 border w-8 h-8 rounded"><i class="fa-solid fa-bars"></i></button> -->
      </div>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>

import Button from '@/components/noc_ui/Button.vue'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

import HelloWorld from '@/components/HelloWorld.vue'
import ModalAddPlayer from '@/components/ModalAddPlayer.vue'
import Input from '@/components/noc_ui/Input.vue'
import MobileNavbar from '@/components/MobileNavbar.vue'
import Login from '@/components/Login.vue'

export default {
  components: {
    HelloWorld,
    Vue3EasyDataTable,
    Button,
    ModalAddPlayer,
    Input,
    MobileNavbar,
    Login
  },
  data() {
    return {
      email: '',
      is_edit: false,
      stat_update: {
        id_player: '',
        name: '',
        is_fc: 0,
        furnice_level: 0,
        power: 0
      },
      headers: [
          { text: "ID", value: "id_player" },
          { text: "NAME", value: "name"},
          { text: "LEVEL", value: "furnice_level"},
          { text: "POWER", value: "power"},
          { text: "ACTION", value: "actions", sortable: false }
      ],
      players: [
        {},
      ]
    }
  },
  async created(){
    const { data: { session } } = await this.$supabase.auth.getSession()
    if ( session ) {
      this.$auth.is = true
      this.$auth.user = session.user
      this.email = session.user.email
    } else {
      this.$auth.is = false
      this.$auth.user = null
    }
  },
  methods: {
    async buttonLoginHandle(){
      if ( this.$auth.is ) {
        this.$Swal.fire({
          html: `<div><b>Logout ?</b></div>`,
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: 'red',
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.$loading.is = true
            await this.$auth.logout()
            window.location.reload()
            this.$loading.is = false
          }
        })
      } else {
        this.$noc('#modalLogin').modal('show')
      }
    }
  },
  mounted() {

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
